import { Component } from '@angular/core';
import { sleep } from '../../../utils/utils';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'clients-say',
    standalone: true,
    imports: [NgStyle],
    templateUrl: './clients-say.html',
    styleUrl: './clients-say.less',
})
export class ClientsSayComponent {
    currentIndex: number = 0;
    totalSlides: number = 5;

    constructor() {}

    ngOnInit(): void {
        this.init();
    }

    getStyleDesktop(index: number) {
        const prev: number = this.currentIndex - 1 < 0 ? this.totalSlides - 1 : this.currentIndex - 1;
        const next: number = this.currentIndex + 1 > this.totalSlides - 1 ? 0 : this.currentIndex + 1;
        let translateX: string = `-5%`;
        if (index === prev) translateX = `-10%`;
        if (index === next) translateX = `10%`;

        return {
            transform: `translateX(${translateX}) scale(${index === this.currentIndex ? '1' : '0.8'})`,
            'z-index': index === this.currentIndex ? '41' : '40',
            opacity: index !== this.currentIndex && index !== prev && index !== next ? '0' : '1',
            left: index === this.currentIndex ? '10%' : undefined,
        };
    }

    getStyle(index: number) {
        const prev: number = this.currentIndex - 1 < 0 ? this.totalSlides - 1 : this.currentIndex - 1;
        const next: number = this.currentIndex + 1 > this.totalSlides - 1 ? 0 : this.currentIndex + 1;
        let translateX: string = `0%`;
        if (index === prev) translateX = `-10%`;
        if (index === next) translateX = `10%`;

        return {
            transform: `translateX(${translateX})`,
            'z-index': index === this.currentIndex ? '51' : '50',
            opacity: index !== this.currentIndex ? '0' : '1',
        };
    }

    init(): void {
        let autoPlay: ReturnType<typeof setInterval> = setInterval(() => {
            this.nextSlide();
        }, 5000);

        const containers: HTMLElement[] = Array.from(document.querySelectorAll('.carousel-container')) as HTMLElement[];
        containers.forEach((container: HTMLElement) => {
            container.addEventListener('mouseenter', () => {
                clearInterval(autoPlay);
            });

            container.addEventListener('mouseleave', () => {
                autoPlay = setInterval(() => {
                    this.nextSlide();
                }, 4000);
            });
        });
    }

    clickDot(index: number): void {
        this.currentIndex = index;
        this.updateCarousel();
    }

    updateCarousel(): void {
        const dots: HTMLElement[] = Array.from(document.querySelectorAll('.nav-dot'));
        dots.forEach((dot) => {
            dot.classList.toggle('active', parseInt(dot.getAttribute('data-index') || '0') === this.currentIndex);
        });
    }

    nextSlide(): void {
        this.currentIndex++;
        if (this.currentIndex > this.totalSlides - 1) {
            this.currentIndex = 0;
        }
        this.updateCarousel();
    }
}
